module.exports = __webpack_public_path__ + "static/img/15areaB_1.8caf4ec.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/15areaB_1.png
// module id = 1123
// module chunks = 1